export const rbacFlags = {
  CockpitReports: 'CockpitReports',
  CockpitReportsScheduledReports: 'CockpitReportsScheduledReports',
  CockpitVouchers: 'CockpitVouchers',
  CockpitVouchersOrganisationBalance: 'CockpitVouchersOrganisationBalance',
  CockpitVouchersReports: 'CockpitVouchersReports',
  CockpitVouchersVendorBalance: 'CockpitVouchersVendorBalance',
};

const normalizeAccessList = accessPayload => {
  if (!accessPayload) {
    return [];
  }

  return Array.isArray(accessPayload) ? accessPayload : [accessPayload];
};

/**
 * Builds Redux RBAC state from get-logged-in-user-access.
 * That API now returns only isSuperAdmin; module grants must come from an
 * explicit access payload (legacy response) or admin-details bootstrap data.
 */
export const parseLoggedInUserRbac = (accessData, adminDetailsData) => {
  const isSuperAdmin = Boolean(accessData?.isSuperAdmin);

  const explicitAccess = accessData?.access;
  if (explicitAccess) {
    return {
      isSuperAdmin,
      access: normalizeAccessList(explicitAccess),
    };
  }

  const adminAccess = adminDetailsData?.access;
  if (adminAccess) {
    return {
      isSuperAdmin,
      access: normalizeAccessList(adminAccess),
    };
  }

  const adminModules = adminDetailsData?.modules;
  if (Array.isArray(adminModules) && adminModules.length > 0) {
    return {
      isSuperAdmin,
      access: [{ modules: adminModules }],
    };
  }

  return { isSuperAdmin, access: [] };
};

/**
 * Checks if the currently logged-in user has access to a specific flagName.
 *
 * @param {string} flagName - The RBAC module flagName to verify.
 * @param {object} rbacState - The 'rbac' state from Redux store (containing access and flags).
 * @returns {boolean} True if the user has access; False otherwise.
 */
export const isSuperAdminUser = rbacState =>
  Boolean(rbacState?.isLoaded && rbacState?.isSuperAdmin);

export const checkUserAccess = (flagName, rbacState) => {
  if (isSuperAdminUser(rbacState)) {
    return true;
  }

  if (!rbacState?.isLoaded) {
    return false;
  }

  const accessList = rbacState?.access || [];
  const userAccess = accessList[0];
  if (!userAccess) {
    return false;
  }

  if (userAccess.modules && Array.isArray(userAccess.modules)) {
    if (userAccess.modules.some(m => m.flagName === flagName)) {
      return true;
    }
  }

  if (userAccess.moduleIds && userAccess.moduleIds.includes(flagName)) {
    return true;
  }

  return false;
};
